export default __webpack_public_path__ + "static/media/icons8-document.97abe01d.svg";